@if (currentUser$(); as currentUser) {
<bs-header [isDarkTheme]="isDarkTheme$()" [languages]="languages$()" [currentLanguage]="currentLanguage$()"
    [notifications]="notifications$()" settingsUrl="/me/settings" [username]="currentUser$()?.userName ?? ''"
    (languageChange)="languageChange($event)" (notificationClick)="handleNotificationClick($event)"
    (readAllNotifications)="handleReadAllNotifications()" (logout)="logout()" (darkThemeToggle)="toggleDarkTheme()">
    <ng-container navItems>
        <bs-header-nav-item label="GLOBAL.GLOBAL.WORKFLOW" url="workflow" />
        <bs-header-nav-item label="GLOBAL.GLOBAL.ADMINISTRATION" url="admin" />
        <bs-header-nav-item label="GLOBAL.GLOBAL.HELP" url="help" />
    </ng-container>
    <ng-container additionalActions>
        @if (currentUser.environments?.length > 1 && !isMultiEnvironment()) {
        <div>
            <bs-dropdown-button-trigger [dropdown]="dropdown">
                <div class="environment-toggle" trigger>
                    <span class="fas fa-chevron-down icon"></span>
                    <div>{{ currentEnvironment()?.name }}</div>
                </div>
            </bs-dropdown-button-trigger>
            <bs-dropdown-list #dropdown dropdownId="environmentDropdown">
                @for (environment of currentUser.environments; track environment.id) {
                <bs-dropdown-list-option class="environment-item" [id]="'environment_' + environment.id"
                    (click)="handleEnvironmentChange(environment)">
                    {{ environment.name }}
                </bs-dropdown-list-option>
                }
            </bs-dropdown-list>
        </div>
        }
    </ng-container>
</bs-header>
}